// src/components/Assets/LogoNav.js
import React from "react";
import { Link } from "react-router-dom";

const LogoNav = ({ to = "/" }) => {
  return (
    <Link to={to}>
      <img
        src="/assets/img/logonav.png"
        alt="YASKIA"
        title="YASKIA"
        className="logo"
      />
    </Link>
  );
};

export default LogoNav;
